import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardMedia,
	Grid,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import Link from 'next/link';

import { SuccessCard } from '@src/lib/__generated/contentful/sdk';

export default function MarketingCard({ card }: { card: SuccessCard }) {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Grid item xs={12} sm={6} md={4} key={card?.sys?.id}>
			<Card elevation={0} variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
				<CardMedia component="img" image={card.cardImage?.url ?? ''} alt={card.imageAltText ?? ''} />
				<CardContent sx={{ marginBottom: 'auto' }}>
					<Typography sx={{ mb: 3 }} variant="header3" color="text.primary">
						{card.titleText}
					</Typography>
					<Typography variant={isSmallScreen ? 'bodySmallBook' : 'bodyMediumBook'} color="text.secondary">
						{card.descriptionText}
					</Typography>
				</CardContent>
				<CardActions>
					<Button variant="primaryHC" component={Link} size="M" href={card.buttonLink ?? ''}>
						{card.buttonText}
					</Button>
				</CardActions>
			</Card>
		</Grid>
	);
}
